import React from 'react';
import { cn } from 'src/tef/components/utils/cn';
import { forwardProps } from 'src/tef/components/utils/forwardProps';
import type { ForwardedHTMLProps } from 'src/tef/components/utils/types';

interface SpacerComponentProps extends ForwardedHTMLProps {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl';
  className?: string;
}

const spacerSizes = {
  xs: 'h-1',
  sm: 'h-2',
  md: 'h-4',
  lg: 'h-6',
  xl: 'h-8',
  '2xl': 'h-10',
};

export const SpacerComponent = React.forwardRef<HTMLDivElement, SpacerComponentProps>(
  ({ size = 'md', className, ...props }, ref) => {
    const forwardedProps = forwardProps(props);

    return <div ref={ref} className={cn(spacerSizes[size], className)} {...forwardedProps} {...props} />;
  }
);

SpacerComponent.displayName = 'SpacerComponent';
